import type { LeCoffreAuthContext } from "@Front/Utils/lecoffreSessionCookieHelpers";

const STORAGE_KEY = "lecoffre_active_session_family";

export function setActiveSessionFamily(context: LeCoffreAuthContext): void {
	if (typeof window === "undefined") {
		return;
	}
	window.sessionStorage.setItem(STORAGE_KEY, context);
}

export function clearActiveSessionFamily(): void {
	if (typeof window === "undefined") {
		return;
	}
	window.sessionStorage.removeItem(STORAGE_KEY);
}

export function getActiveSessionFamily(): LeCoffreAuthContext | null {
	if (typeof window === "undefined") {
		return null;
	}
	const raw = window.sessionStorage.getItem(STORAGE_KEY);
	if (raw === "notary" || raw === "customer" || raw === "thirdparty") {
		return raw;
	}
	return null;
}
